import type { ReactNode } from 'react'
import { Nav } from './Nav'
import { Footer } from './Footer'
import type { SectionId } from '../design/sections'

interface LayoutProps {
  section?: 'home' | SectionId
  children: ReactNode
}

/**
 * Wraps every page. Sets the section data attribute (which controls the
 * --accent CSS variable used everywhere from the cursor to the artifact
 * frames), and frames the content with nav+footer. The custom cursor that
 * used to live here has been removed in favour of the native browser cursor.
 */
export function Layout({ section = 'home', children }: LayoutProps) {
  return (
    <div data-section={section} className="min-h-dvh bg-[color:var(--color-bg)]">
      <Nav />
      <main className="pt-24">{children}</main>
      <Footer />
    </div>
  )
}
